export enum INTEGRITY_CHECK_TYPE {
  BASE_INFO = 1,
  BOM_INFO = 2,
  PRICE_INFO = 3,
  CUSTOM_FIELD = 4,
}
export const TYPE_NAME_MAP: Record<number, string> = {
  [INTEGRITY_CHECK_TYPE.BASE_INFO]: '基础信息',
  [INTEGRITY_CHECK_TYPE.CUSTOM_FIELD]: '自定义基础信息',
  [INTEGRITY_CHECK_TYPE.BOM_INFO]: '物料BOM',
  [INTEGRITY_CHECK_TYPE.PRICE_INFO]: '价格',
};
/*
  完整性校验 将配置存储到company_config,需要注意的是company_config的长度最大支持1500,可能会不够
  因此采用将2进制形式存储：如 0111111(代表第一个为未开启状态，其余开启)
  每个模块的在二进制数组中的存储顺序由index指定，也代表获取相应值时也是从相应的位置取值，
  此做法旨在兼容可能改变字段顺序的情况，因此index与字段的映射由前后端共同维护
*/
/**
 * {
 *  type 模块的类型
 *  text 字段标题
 *  field 表格字段
 *  status 默认值
 *  remark 说明
 *  isDefault 是否默认必填 (按钮开启且不可修改)
 *  index 二进制数组中的存储位置，原则上应递增
 * }
 *
 * */
// 基础信息模块 基础数据
export const initBaseData: Array<Recordable> = [
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '款式图',
    field: 'image',
    status: 0,
    index: 0,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '设计款号',
    field: 'designSn',
    status: 1,
    index: 1,
    isDefault: true,
    remark: '设计款管理系统默认必填，商品管理可不填',
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '名称',
    field: 'name',
    status: 1,
    index: 2,
    isDefault: true,
    remark: '系统默认必填',
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '货号',
    field: 'goodsSn',
    status: 1,
    index: 3,
    isDefault: true,
    remark: '系统默认必填',
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '颜色',
    field: 'colorList',
    status: 0,
    index: 4,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '尺码',
    field: 'sizeList',
    status: 0,
    index: 5,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '来源',
    field: 'sampleSource',
    status: 0,
    index: 6,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '供应商货号',
    field: 'supplierSn',
    status: 0,
    index: 7,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '开发日期',
    field: 'devTime',
    status: 0,
    index: 8,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '客户',
    field: 'clientId',
    status: 0,
    index: 9,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '企划名称',
    field: 'planId',
    status: 0,
    index: 10,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '品牌',
    field: 'blandId',
    status: 0,
    index: 11,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '分类',
    field: 'categoryId',
    status: 0,
    index: 12,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '性别',
    field: 'sex',
    status: 0,
    index: 13,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '款式',
    field: 'styleId',
    status: 0,
    index: 14,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '季节',
    field: 'seasonId',
    status: 0,
    index: 15,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '年份',
    field: 'year',
    status: 0,
    index: 16,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '克重',
    field: 'gramWeight',
    status: 0,
    index: 17,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '成分',
    field: 'composition',
    status: 0,
    index: 18,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '波段',
    field: 'rangesId',
    status: 0,
    index: 19,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '廓形',
    field: 'silhouette',
    status: 0,
    index: 20,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '设计师',
    field: 'designer',
    status: 0,
    index: 21,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '加工厂',
    field: 'factoryId',
    status: 0,
    index: 22,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '设计助理',
    field: 'designAssistantId',
    status: 0,
    index: 29,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '跟单员',
    field: 'followerId',
    status: 0,
    index: 23,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '打版师',
    field: 'patternMakerId',
    status: 0,
    index: 24,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '备注',
    field: 'remark',
    status: 0,
    index: 25,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '预计首单数量',
    field: 'firstOrderCount',
    status: 0,
    index: 26,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '首单日期',
    field: 'firstOrderTime',
    status: 0,
    index: 27,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BASE_INFO,
    text: '首翻日期',
    field: 'reorderOrderTime',
    status: 0,
    index: 28,
  },
];
// 价格模块 基础数据
export const initPriceData = [
  {
    type: INTEGRITY_CHECK_TYPE.PRICE_INFO,
    text: '吊牌价',
    field: 'tagPrice',
    status: 0,
    index: 0,
  },
  {
    type: INTEGRITY_CHECK_TYPE.PRICE_INFO,
    text: '建议零售价',
    field: 'retailPriceFactory',
    status: 0,
    index: 1,
  },
  {
    type: INTEGRITY_CHECK_TYPE.PRICE_INFO,
    text: '成本价',
    field: 'costPrice',
    status: 0,
    index: 2,
  },
  {
    type: INTEGRITY_CHECK_TYPE.PRICE_INFO,
    text: '批发价',
    field: 'tradePrice',
    status: 0,
    index: 3,
  },
  {
    type: INTEGRITY_CHECK_TYPE.PRICE_INFO,
    text: '零售价',
    field: 'retailPriceArea',
    status: 0,
    index: 4,
  },
];
// 物料bom模块 基础数据
export const initBomData = [
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '供应商',
    field: 'supplierId',
    status: 0,
    index: 0,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '基础单价',
    field: 'price',
    status: 0,
    index: 1,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '采购单价',
    field: 'purchasePrice',
    status: 0,
    index: 2,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '使用部位',
    field: 'materialPart',
    status: 0,
    index: 3,
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '物料颜色',
    field: 'materialColor',
    status: 1,
    index: 4,
    isDefault: true,
    remark: '系统默认必填',
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '物料规格',
    field: 'materialSpec',
    status: 1,
    index: 5,
    isDefault: true,
    remark: '系统默认必填',
  },
  {
    type: INTEGRITY_CHECK_TYPE.BOM_INFO,
    text: '用量',
    field: 'number',
    status: 1,
    index: 6,
    // isDefault: true,
    // remark: '系统默认必填',
  },
];
